import type { AxiosInstance } from "axios";
import { Mapper } from "../../../../../../lib/utils/mapper";
import { getBonusxApiConfigV1, getBonusxApiConfigV2 } from "../../../../../common/bonusxApiConfig";
import { ProductDto } from "../../../../../pages/ProductsListPage/dtos/product/product.dto";
import type { IProductDto } from "../../../../../pages/ProductsListPage/dtos/product/product.dto.interface";
import axiosInstance from "../../../../axios-config-singleton/axios-config-singleton.instance";
import type { ISearchHistoryDto } from "../../../dtos/search-history.dto";
import { SearchHistoryDto } from "../../../dtos/search-history.dto";
import type { ISearchHistoryRemoteDatasource } from "./search-history-remote.datasource.interface";

export class SearchHistoryRemoteDatasource implements ISearchHistoryRemoteDatasource {
  private readonly _SEARCH_HISTORY_URL = "/citizen/history/services";
  private readonly _SEARCH_HISTORY_LIMIT_PARAM = "limit";
  private readonly _CLIENT_OPTIONS = getBonusxApiConfigV1();

  private readonly _CLIENT_OPTIONS_V2 = getBonusxApiConfigV2();
  private readonly _SEARCH_HISTORY_URL_V2 = "/product-history";

  constructor(private readonly _client: AxiosInstance = axiosInstance) {}

  async getSearchHistory(limit: number): Promise<ISearchHistoryDto> {
    const response = await this._client.get(this._SEARCH_HISTORY_URL, {
      params: {
        [this._SEARCH_HISTORY_LIMIT_PARAM]: limit,
      },
      ...this._CLIENT_OPTIONS,
    });

    return new SearchHistoryDto(response?.data?.history);
  }

  async getProductHistory(limit: number): Promise<IProductDto[]> {
    const response = await this._client.get<IProductDto[]>(this._SEARCH_HISTORY_URL_V2, {
      params: {
        [this._SEARCH_HISTORY_LIMIT_PARAM]: limit,
      },
      ...this._CLIENT_OPTIONS_V2,
    });

    const responseData = response?.data;
    const dtos = Mapper.mapArrayData(ProductDto, responseData);

    return dtos;
  }
}
